import { render, staticRenderFns } from "./VAppSidebarNavigationListItem.vue?vue&type=template&id=7bf88d0b&"
import script from "./VAppSidebarNavigationListItem.vue?vue&type=script&lang=ts&"
export * from "./VAppSidebarNavigationListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports